<template>
    <div class="consult-container">
        <ComDetail :detail="detail" :detailCols="detailCols" :onCancel="onCancel"></ComDetail>
        <div class="search-container">
            <el-form :inline="true" :model="formInline" class="demo-form-inline">
                <el-form-item label="应用名称">
                    <el-input v-model="formInline.appName" placeholder="请输入应用名称"></el-input>
                </el-form-item>
                <el-form-item label="应用类型">
                    <el-select v-model="formInline.type" placeholder="请选择" clearable>
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="onSubmit">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="table-container">
            <el-table v-loading="tableLoading" :data="tableData" :pagination="pagination" border style="width: 100%">
                <el-table-column prop="appName" label="应用名称" align="center">
                </el-table-column>
                <el-table-column prop="createDate" label="申请时间" align="center" :formatter="dateFormat">
                </el-table-column>
                <el-table-column prop="appType" align="center" label="应用类型">
                    <!-- <template slot-scope="scope">
                        <span>{{ scope.row.appType ? options.find(it => Number(it.value) == scope.row.appType).label :
                            '-' }}</span>
                    </template> -->
                    <template slot-scope="scope">
                        <span> {{
                            options.find(it => Number(it.value) === scope.row.appType)
                                ? options.find(it => Number(it.value) === scope.row.appType).label
                                : '-'
                        }}</span>
                    </template>

                </el-table-column>
                <el-table-column prop="serverName" align="center" label="服务商">
                </el-table-column>
                <el-table-column prop="reviewStatus" align="center" label="审核状态">
                    <template slot-scope="scope">
                        <span v-if="scope.row.reviewStatus === 0">未审核</span>
                        <span v-else-if="scope.row.reviewStatus === 1">已通过</span>
                        <span v-else-if="scope.row.reviewStatus === 2">未通过</span>
                        <span v-else>未知状态</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="100">
                    <template slot-scope="scope">
                        <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
                        <el-button v-if="scope.row.reviewStatus === 0" type="text" size="small"
                            @click="handleReplyClick(scope.row)">审核</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-container">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="pagination.pageNo" :page-sizes="[10, 20, 30, 40]" :page-size="pagination.pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="pagination.total">
                </el-pagination>
            </div>
        </div>
        <!-- 审核功能 -->
        <el-drawer title="审核" :visible.sync="drawer" direction="rtl" :before-close="handleClose">
            <el-form ref="form" :model="drawerForm" label-width="80px">
                <el-form-item label="审核结果">
                    <el-radio-group v-model="drawerForm.result">
                        <el-radio :label="0">通过</el-radio>
                        <el-radio :label="1">不通过</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="原因" v-if="drawerForm.result === 1">
                    <el-input rows="4" type="textarea" v-model="drawerForm.reason" placeholder="请输入原因"></el-input>
                </el-form-item>
            </el-form>
            <div class="drawer-footer">
                <el-button @click="cancelForm">取 消</el-button>
                <el-button type="primary" @click="submitReview" :loading="loading">{{ loading ? '提交中 ...' : '确 定'
                    }}</el-button>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import { appTypeDict2 } from '@/data/constant'
import { getAppAuditList, getAppAudit } from '@/api/SupermarketOperation'
import moment from "moment";
import ComDetail from '@/components/common/comDetail.vue';
export default {
    name: 'AdminStaticsApplication',
    components: {
        ComDetail
    },
    data() {
        return {
            tableLoading: false,
            detail: {
                visible: false,
                record: {},
            },
            detailCols: [
                {
                    label: '应用名称',
                    prop: 'appName'
                },
                {
                    label: '申请时间',
                    prop: 'createDate',
                    formatter: (row) => moment(row.createDate).format('YYYY-MM-DD HH:mm:ss'),
                },
                {
                    label: '应用类型',
                    prop: 'appType',
                    formatter: (row) => {
                        // 找到 row.appType 在 this.options 中对应的选项
                        const option = this.options.find(it => Number(it.value) === row.appType);
                        // 如果找到对应的选项，则返回其 label，否则返回 '-'
                        return option ? option.label : '-';
                    }
                },
                {
                    label: '服务商',
                    prop: 'serverName'
                },
            ],
            options: appTypeDict2,
            drawer: false,
            formInline: {
                type: '',
                appName: '',
            },
            pagination: {
                pageNo: 1, // 当前页
                pageSize: 10, // 每页显示条数
                total: 0, // 总条数
                layout: 'total, prev, pager, next, jumper', // 分页布局
            },
            tableData: [],
            drawerForm: {
                result: 0,
                reason: '',
            },
            record: {},
        };
    },

    mounted() {
        this.loadData()
    },
    methods: {
        // 查看
        onCancel() {
            this.detail.visible = false
        },
        cancelForm() {
            this.drawer = false
        },
        async submitReview() {
            const params = {
                result: this.drawerForm.result
            }
            if (this.drawerForm.result === 1) {
                params.reason = this.drawerForm.reason
            }
            await getAppAudit({
                appOnId: this.record.id,
                appId: this.record.appId,
                memberId: this.record.memberId,
                ...params,
                reviewType: 1,
            }).then(() => {
                this.$message.success('审核成功')
                this.drawer = false
                this.record = {}
                this.loadData()
            })
        },
        // 时间转换
        dateFormat(row) {
            return moment(row.createDate).format('YYYY-MM-DD HH:mm:ss');
        },
        handleSizeChange(val) {
            this.pagination.pageSize = val
            this.loadData()
        },
        handleCurrentChange(val) {
            this.pagination.pageNo = val
            this.loadData()
        },
        handleClick(row) {
            this.detail.visible = true
            this.detail.record = row
        },
        handleReplyClick(row) {
            this.drawer = true
            this.record = row
        },
        onSubmit() {
            this.pagination.pageNo = 1
            this.loadData()
        },
        async loadData() {
            this.tableLoading = true
            const params = {
                pageNo: this.pagination.pageNo - 1,
                pageSize: this.pagination.pageSize
            }
            if (this.formInline.type) {
                params.appType = Number(this.formInline.type)
            }
            if (this.formInline.appName) {
                params.appName = this.formInline.appName
            }
            await getAppAuditList(params).then(res => {
                this.tableData = res.data.content
                this.pagination.total = res.data.totalElements
                this.tableLoading = false
            })
        }
    },
};
</script>
<style lang="scss" scoped>
.consult-container {
    background: #fff;
    padding: 24px 0;

    .search-container {
        padding: 0 16px;
        border-bottom: 1px solid #EBEEF5;
    }

    .table-container {
        padding: 16px;
    }

    .pagination-container {
        margin-top: 16px;
        text-align: right;
    }

    .drawer-footer {
        text-align: center;
    }
}

::v-deep .el-drawer__body {
    padding: 0 16px;
}
</style>